import {
  MedicationSearchResult,
  ParsedArticleSearchResult,
  SearchContentType,
} from '@novaheal/types';
import { ImageSearchResult } from '@novaheal/types/lib/search/imageSearch';
import { VideoSearchResult } from '@novaheal/types/lib/search/videoSearch';

export type SearchResultWithParsedArticle =
  | MedicationSearchResult
  | ParsedArticleSearchResult
  | VideoSearchResult
  | ImageSearchResult;

const isArticleSearchResult = (
  result: SearchResultWithParsedArticle
): result is ParsedArticleSearchResult => result.contentType === SearchContentType.ARTICLE;

const isMedicationSearchResult = (
  result: SearchResultWithParsedArticle
): result is MedicationSearchResult => result.contentType === SearchContentType.MEDICATION;

const isVideoSearchResult = (result: SearchResultWithParsedArticle): result is VideoSearchResult =>
  result.contentType === SearchContentType.VIDEO;

const isImageSearchResult = (result: SearchResultWithParsedArticle): result is ImageSearchResult =>
  result.contentType === SearchContentType.IMAGE;

export {
  isArticleSearchResult,
  isImageSearchResult,
  isMedicationSearchResult,
  isVideoSearchResult,
};
